import React, { useMemo, useState } from "react";
import styles from "./ManageDiscount.module.css";
import Header from "../../components/header/Header";
import { useToast } from "../../hooks/useToast";
import PageHeading from "../../components/PageHeading/PageHeading";
import {
  useGetDiscountsQuery,
  useUpdateDiscountMutation,
} from "../../store/api/discountApi";

interface IDiscountForm {
  inHousePercentage?: number;
  thirdPartyPercentage?: number;
}

const ManageDiscount: React.FC = () => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState<IDiscountForm>({
    inHousePercentage: 0,
    thirdPartyPercentage: 0,
  });

  const { data: discounts, isLoading } = useGetDiscountsQuery();

  const [updateDiscount, { isLoading: isUpdating }] =
    useUpdateDiscountMutation();

  const discountArryForForm = useMemo(
    () =>
      discounts?.data?.map((discount) => {
        if (discount?.type === 1) {
          setFormData((prev) => ({
            ...prev,
            inHousePercentage: discount.discount,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            thirdPartyPercentage: discount.discount,
          }));
        }
        return {
          ...discount,
          dType:
            discount?.type === 1 ? "inHousePercentage" : "thirdPartyPercentage",
          label:
            discount?.type === 1
              ? "In-House Discount (%)"
              : "Third-Party Discount (%)",
        };
      }),
    [discounts]
  );
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numValue = Math.min(100, Math.max(0, Number(value)));
    setFormData((prev) => ({
      ...prev,
      [name]: numValue,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let payload = {
      id: discountArryForForm?.find(
        (discount) => discount.dType === "inHousePercentage"
      )?.id,
      discount: formData.inHousePercentage || formData.thirdPartyPercentage,
    };
    try {
      await updateDiscount(payload);
      showToast("Discount percentages updated successfully", "success");
    } catch (error) {
      showToast("Error updating discount percentages", "error");
    }
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Manage Discount" />
        <div className={styles.content}>
          <form onSubmit={handleSubmit} className={styles.form}>
            {discountArryForForm?.map((discount) => (
              <div key={discount.id} className={styles.formGroup}>
                <label htmlFor={discount.dType}>{discount.label}</label>
                <input
                  type="number"
                  id={discount.dType}
                  name={discount.dType}
                  value={formData[discount.dType as keyof IDiscountForm]}
                  onChange={handleInputChange}
                  min="0"
                  max="100"
                  step="0.01"
                  required
                />
              </div>
            ))}

            {/*             
            <div className={styles.formGroup}>
              <label htmlFor="inHousePercentage">In-House Discount (%)</label>
              <input
                type="number"
                id="inHousePercentage"
                name="inHousePercentage"
                value={formData.inHousePercentage}
                onChange={handleInputChange}
                min="0"
                max="100"
                step="0.01"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="thirdPartyPercentage">
                Third-Party Discount (%)
              </label>
              <input
                type="number"
                id="thirdPartyPercentage"
                name="thirdPartyPercentage"
                value={formData.thirdPartyPercentage}
                onChange={handleInputChange}
                min="0"
                max="100"
                step="0.01"
                required
              />
            </div> */}

            <button
              type="submit"
              className={styles.submitButton}
              onClick={handleSubmit}
            >
              Save Changes
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageDiscount;
